import { HalfMoon, SunLight } from 'iconoir-react'
import { useEffect, useState } from 'react'

// Reads the theme index.html's inline script already set on <html> (no
// flash of the wrong colors on load), then just flips [data-theme] and
// mirrors the choice to localStorage under the same "fs-theme" key.
export function ThemeToggle() {
  const [isLight, setIsLight] = useState(false)

  useEffect(() => {
    setIsLight(document.documentElement.dataset.theme === 'light')
  }, [])

  function toggle() {
    const next = isLight ? 'dark' : 'light'
    setIsLight(!isLight)
    if (next === 'light') {
      document.documentElement.dataset.theme = 'light'
    } else {
      delete document.documentElement.dataset.theme
    }
    try {
      localStorage.setItem('fs-theme', next)
    } catch {
      /* private browsing / storage blocked -- theme just won't persist */
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      data-cursor="link"
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-n-500 transition-colors hover:bg-n-400 hover:text-ink"
    >
      {isLight ? <HalfMoon width={18} height={18} /> : <SunLight width={18} height={18} />}
    </button>
  )
}
